<div
  class="vc-layout"
  [class.vc-layout--sidebar-open]="isSidebarOpen && isAuthenticated"
>
  <!-- Sidebar (only when authenticated) -->
  @if (isAuthenticated) {
  <app-sidebar
    [isOpen]="isSidebarOpen"
    (closeSidebar)="closeSidebar()"
  ></app-sidebar>
  }

  <!-- Main content area -->
  <div class="vc-layout__main">
    <!-- Top bar (only when authenticated) -->
    @if (isAuthenticated) {
    <app-topbar
      [pageTitle]="currentPageTitle"
      [pageIcon]="currentPageIcon"
      [isSidebarOpen]="isSidebarOpen"
      (toggleSidebar)="toggleSidebar()"
    ></app-topbar>
    }

    <!-- Content -->
    <main
      class="vc-layout__content"
      [class.vc-layout__content--authenticated]="isAuthenticated"
      [class.vc-layout__content--public]="!isAuthenticated"
    >
      @if (isAuthenticated) {
      <div class="vc-layout__content-inner">
        <router-outlet></router-outlet>
      </div>
      } @else {
      <router-outlet></router-outlet>
      }
    </main>

    <!-- Footer (only when authenticated) -->
    @if (isAuthenticated) {
    <footer class="vc-layout__footer">
      <div class="vc-layout__footer-content">
        <span>© {{ currentYear }} Virtualcenter - Clinic Management Software</span>
        <span>v1.0.0</span>
      </div>
    </footer>
    }
  </div>

  <!-- Overlay for mobile (click to close sidebar) -->
  @if (isSidebarOpen && isAuthenticated) {
  <div class="vc-layout__overlay" (click)="closeSidebar()"></div>
  }
</div>
